import styled from '@emotion/styled'
import { FusionInterfaceZIndex, L1BaseShmoopie } from "@fusion-advantage/formrender"
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { useCallback } from 'react'
import { updateRenderState } from '../../../lib/relay/updateRenderState'

const L4T1NavTriggerContainer = styled.div(({theme}) => ({
	position: 'fixed',
	zIndex: FusionInterfaceZIndex.NavTrigger,
	top: theme.statusBarHeightPx,
	left: 0,
}))

const L4T1NavTrigger = () => {
	const availableFor = useAppSelector(state => state.render.t1NavAvailableFor)
	const open = useAppSelector(state => state.render.t1NavOpen)
	const dispatch = useAppDispatch()
	const handleHamburgerClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
		// prevent incrementBackgroundTaps
		// from closing the nav immediately
		e.stopPropagation()
		dispatch(updateRenderState({t1NavOpen: !open}))
	}, [dispatch, open])
	if(Object.values(availableFor).reduce((p,c) => c||p, false)) {
		return (
			<L4T1NavTriggerContainer>
				<L1BaseShmoopie
					hamburgerOpen={open}
					onHamburgerClick={handleHamburgerClick}
				/>
			</L4T1NavTriggerContainer>
		)
	}
	return null
}

export default L4T1NavTrigger
